module.exports = __webpack_public_path__ + "static/img/logo.676fe95e.svg";